var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTimes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 73.3 81.5",
    style: {
      enableBackground: "new 0 0 73.3 81.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#4C54F3;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_637"
  }, /*#__PURE__*/React.createElement("g", {
    id: "assessment-24px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trac\\xE9_1309"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 23.9,
    className: "st0",
    width: 5.2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 31.8,
    className: "st0",
    width: 8.1,
    height: 2.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 39.7,
    className: "st0",
    width: 5.2,
    height: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "43.8,34.1 50.6,39 48.8,41.7 40.6,35.9 40.6,23.4 43.8,23.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.8,11.7L42.8,11.7c-11.3,0.1-20.4,9.4-20.3,20.7c0.1,11.2,9.3,20.2,20.4,20.2h0.2 c11.2-0.1,20.2-9.3,20.2-20.5C63.3,20.9,54.1,11.7,42.8,11.7z M42.8,50L42.8,50c-2.5,0-4.8-0.5-6.9-1.4c-2.1-0.9-4.1-2.2-5.7-3.9 c-3.3-3.4-5.1-7.9-5.1-12.6c0-4.8,1.9-9.2,5.3-12.5s7.8-5.1,12.5-5.1h0.2c9.7,0.1,17.6,8.1,17.6,17.8C60.7,42,52.6,50,42.8,50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-12-8.4v97.6h97.5V-8.4H-12z M69.6,73.3h-66v-66h66V73.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_585",
    transform: "translate(12.68 12.753)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_985",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 11.2,
    className: "st0",
    width: 5.2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.6,
    y: 19.1,
    className: "st0",
    width: 8.1,
    height: 2.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 27,
    className: "st0",
    width: 5.2,
    height: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "31.1,21.4 37.9,26.2 36.1,28.9 27.9,23.1 27.9,10.7 31.1,10.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.2-1L30.2-1C18.8-0.9,9.7,8.3,9.8,19.6c0.1,11.2,9.3,20.2,20.4,20.2h0.2c11.2-0.1,20.2-9.3,20.2-20.5 C50.7,8.1,41.4-1,30.2-1z M30.1,37.2L30.1,37.2c-2.5,0-4.8-0.5-6.9-1.4s-4.1-2.2-5.7-3.9c-3.3-3.4-5.1-7.9-5.1-12.6 c0-4.8,1.9-9.2,5.3-12.5s7.8-5.1,12.5-5.1h0.2C40.1,1.8,48,9.8,48,19.5C48,29.3,40,37.2,30.1,37.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.8-7c-0.1-0.3-0.3-0.6-0.5-0.8c-0.4-0.4-0.9-0.6-1.4-0.6h-68c-1.1,0-2,0.9-2,2v68c0,1.1,0.9,2,2,2h68 c0.5,0,1-0.2,1.4-0.6c0.2-0.2,0.4-0.5,0.5-0.8c0.1-0.2,0.1-0.4,0.1-0.6v-68C59.9-6.6,59.9-6.8,59.8-7z M56.9,60.6H-9v-66h66 L56.9,60.6L56.9,60.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.8-6.5c-0.1-0.3-0.3-0.6-0.5-0.8c-0.4-0.4-0.9-0.6-1.4-0.6h-68c-1.1,0-2,0.9-2,2v68c0,1.1,0.9,2,2,2h68 c0.5,0,1-0.2,1.4-0.6c0.2-0.2,0.4-0.5,0.5-0.8c0.1-0.2,0.1-0.4,0.1-0.6v-68C59.9-6.1,59.9-6.3,59.8-6.5z M56.9,61.1H-9v-66h66 L56.9,61.1L56.9,61.1z"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "fast",
    transform: "translate(21.571 19.866)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_625",
    transform: "translate(2.926 11.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_624",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_994"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -11.5,
    y: 0.3,
    className: "st2",
    width: 5.2,
    height: 3
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_627",
    transform: "translate(2.926 27.754)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_626",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_995"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -11.5,
    y: 0.3,
    className: "st2",
    width: 5.2,
    height: 3
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_629",
    transform: "translate(0 19.855)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_628",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_996"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -11.5,
    y: 0.3,
    className: "st2",
    width: 8.1,
    height: 2.9
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_631",
    transform: "translate(12.312 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_630",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trac\\xE9_1337"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.9,0.1L8.9,0.1C-2.4,0.2-11.5,9.4-11.4,20.7C-11.3,31.9-2.1,40.9,9,40.9h0.2c11.2-0.1,20.2-9.3,20.2-20.5 C29.4,9.2,20.2,0.1,8.9,0.1z M8.9,38.3L8.9,38.3c-2.5,0-4.8-0.5-6.9-1.4C-0.1,36-2.1,34.7-3.7,33c-3.3-3.4-5.1-7.9-5.1-12.6 c0-4.8,1.9-9.2,5.3-12.5C-0.1,4.5,4.3,2.7,9,2.7h0.2c9.7,0.1,17.6,8.1,17.6,17.8C26.8,30.3,18.8,38.3,8.9,38.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_633",
    transform: "translate(31.065 11.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_632",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trac\\xE9_1338"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "-2.1,15.3 -3.9,18.1 -12,12.3 -12,-0.2 -8.9,-0.2 -8.9,10.5  "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimes);
export default __webpack_public_path__ + "static/media/_icon_times.f1e13cc4c5af519cdb2e38147d942aac.svg";
export { ForwardRef as ReactComponent };